import mobile from '../../../assets/wcs_static/kick_start_your_business_project/assets/toolkit/images/mobile-placeholder.svg'
import business from '../../../assets/ote_static/assets/toolkit/images/YourBusinessOnline.png';
import useSelectOptions from "./useSelectOptions";
import {createClass} from "../../../utils/helper";
import custom from './selectOptions-wcs-custom.css';
import FaqComponent from '../../../components/faq/FaqComponent';
import CardComponent from "../../../components/card/CardComponent";
import heroTitle from "../../../assets/ote_static/assets/toolkit/images/img-hero-title.svg";
const SelectOptions = () => {
    const {antivirusValue,
        getCall,
        taxId,
        microsoftValue,
        mobileValue,
        fixedValue,
        handleChange,
        button,
        phoneNumber,
        translations,
        storeCode,
        faqsData,
        show,
        cards,
        thanks,
        message,
        store,
        url,
        getBack,
        divRef
    }=useSelectOptions();

    const video = `https://ogilvyone.cachefly.net/cosmote/kickstart/kv4.mp4`
    return (
        (show &&
        <>
            <link rel="stylesheet" type="text/css" href={toolkit}/>
            {/*                <link rel="stylesheet" type="text/css" href={customMin}/>*/}
            {/*                    <link rel="stylesheet" type="text/css" href={otegroup}/>*/}
            <title>Kick Start Your Business Project | COSMOTE</title>
            <link href={custom} rel="stylesheet"/>
            <div className="wcst-container d-flex wcs-custom">
                {/*   <div className="col-md-2 p-0 pattern_blue_green">
                 <img
                        src={greenPattern}/>*/}
                    <div className="col-md-2 p-0 side-grey-bg" >

                </div>
                <div className="wcs-custom wcs-custom-page">

                    <div className={createClass("wcs-hero ", thanks ? "wcs-thank-page" : "")}>
                        <div className="wcs-top-hero wcs-with-video">
                            <video autoPlay muted playsInline loop>
                                {/*autoPlay  muted  playsInline="" loop=""*/}
                                <source
                                    src={video}
                                    type="video/mp4"/>
                                    Δες το video με ροές στα χρώματα της COSMOTE και της TELEKOM που ενώνονται.
                            </video>
                            <div className="wcs-title" ref={divRef}>
                                <img
                                    src={heroTitle}
                                    alt="λογότυπο start your business"/>
                            </div>
                            <h1 className="wcs-text">
                                {translations["videoText1"]} <br/>
                                {translations["videoText2"]}
                            </h1>
                        </div>
                        <h1 className="wcs-pre-title"></h1>

                        <h2 className="wcs-sub-title">
                            {translations['choose']}
                        </h2>
                        <div>
                            <div className="fixed_line_box">
                                <form className="mb-20 form__validate" data-form-validate-only="true" id="emailForm"
                                      encType="multipart/form-data" method="post">
                                    <div className="row" style={ thanks ? {display: 'none'} : {display: 'block'}}>
                                        <div className="col-xs-12 col-sm-4 text-align-start">
                                            <div className="form__block form__block--lg">
                                                { /*   <label className="form__label">{translations['taxId']}<sup>*</sup></label> */}
                                                <input id="vatNumber" name="vatNumber"
                                                       className="form__input required form__validate__field non-editable active"
                                                       type="text" placeholder="ΑΦΜ *" data-form-validate-taxid="true" value={taxId ? `${taxId}` : ''}
                                                       data-field-name="ΑΦΜ" required="required" disabled="disabled"/>
                                                <p className="form__error-message">{taxId}</p>
                                            </div>
                                        </div>
                                        {store &&
                                            <div className="col-xs-12 col-sm-4 text-align-start">
                                                <div className="form__block form__block--lg">
                                                    <label className="form__label">{translations['storeCode']}*</label>
                                                    <input id="storeCode" name="storeCode"
                                                           className="form__input required form__validate__field non-editable"
                                                           type="text" placeholder={translations['storeCodeMessage']} value={storeCode ? `${storeCode}` : ''}
                                                           data-field-name="Κωδικός Καταστήματος" onChange={(e)=> handleChange("storeCode",e.target.value)}
                                                    />
                                                    <p className="form__error-message">{translations['storeCodeMessage']}</p>
                                                </div>
                                            </div>
                                        }

                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="wcs-device-container" style={thanks ? {display: "none"} : {} }>
                            <div className="wcs-device wcs-mob">
                                <div className="wcs-device-title col-md-2 col-xs-12 pl-0">
                                    <div className="d-flex justify-content-start align-items-center">
                                        <span className="wcs-device-name text-align-start">{translations['mobile']}</span>
                                    </div>
                                </div>
                                <form className="wcs-device-slider col-md-10 col-xs-12">
                                    <span className="wcs-slider-min">0</span>
                                    <div className="range-wrap">
                                        <div className="range-value" id="mobileSliderRangeV"  style={{ left: `calc(${(mobileValue / 10) * 100}% + 10px)` }}>
                                            <span>{mobileValue}</span></div>
                                        <input id="mobileSliderRange" type="range" min="0" max="10"  step="1" value={mobileValue}
                                               className="range-slider" onChange={(e)=>handleChange("mobile",e.target.value)}/>
                                    </div>
                                    <span className="wcs-slider-max">10</span>
                                </form>
                            </div>
                            <div className="wcs-device wcs-mob">
                                <div className="wcs-device-title col-md-2 col-xs-12 pl-0">
                                    <div className="d-flex justify-content-start align-items-center">
                                        <span className="wcs-device-name text-align-start">{translations['fixed']}</span>
                                    </div>
                                </div>
                                <form className="wcs-device-slider col-md-10 col-xs-12">
                                    <span className="wcs-slider-min">0</span>
                                    <div className="range-wrap">
                                        <div className="range-value" id="fixedSliderRangeV"  style={{ left: `calc(${(fixedValue / 10) * 100}% + 10px)` }}>
                                            <span>{fixedValue}</span></div>
                                        <input id="fixedSliderRange"  type="range" min="0" max="10"  step="1" value={fixedValue}
                                               className="range-slider" onChange={(e)=>handleChange("fixed",e.target.value)}/>
                                    </div>
                                    <span className="wcs-slider-max">10</span>
                                </form>
                            </div>
                            <div className="wcs-device wcs-mob">
                                <div className="wcs-device-title col-md-2 col-xs-12 pl-0">
                                    <div className="d-flex justify-content-start align-items-center">
                                        <span className="wcs-device-name text-align-start">{translations['secureAntivirus']}</span>
                                    </div>
                                </div>
                                <form className="wcs-device-slider col-md-10 col-xs-12">
                                    <span className="wcs-slider-min">0</span>
                                    <div className="range-wrap">
                                        <div className="range-value" id="microsoftSliderRangeV"  style={{ left: `calc(${(antivirusValue / 10) * 100}% + 10px)` }}>
                                            <span>{antivirusValue}</span></div>
                                        <input id="microsoftSliderRange" type="range" min="0" max="10"  step="1" value={antivirusValue}
                                               className="range-slider" onChange={(e)=>handleChange("antivirus",e.target.value)}/>
                                    </div>
                                    <span className="wcs-slider-max">10</span>
                                </form>

                            </div>
                            <div className="wcs-device wcs-mob">
                                <div className="wcs-device-title col-md-2 col-xs-12 pl-0">
                                    <div className="d-flex justify-content-start align-items-center">

                                        <span className="wcs-device-name text-align-start">{translations['microsoft365']}</span>
                                    </div>
                                </div>
                                <form className="wcs-device-slider col-md-10 col-xs-12">
                                    <span className="wcs-slider-min">0</span>
                                    <div className="range-wrap">
                                        <div className="range-value" id="microsoftSliderRangeV"    style={{ left: `calc(${(microsoftValue / 10) * 100}% + 10px)` }}>
                                            <span>{microsoftValue}</span></div>
                                        <input id="microsoftSliderRange" type="range" min="0" max="10" step="1" value={microsoftValue}
                                               className="range-slider" onChange={(e)=>handleChange("microsoft",e.target.value)}/>
                                    </div>
                                    <span className="wcs-slider-max">10</span>
                                </form>
                            </div>
                            <div className="wcs-device wcs-mob m365">
                                <div className="wcs-device-title col-md-2 col-xs-12 pl-0">
                                    <div className="d-flex justify-content-start align-items-center">

                                        <span className="wcs-device-name text-align-start">{translations['microsoft365Apps']}</span>
                                    </div>
                                </div>
                                <div className="container col-md-10 col-xs-12">
                                    <div className="form__checkbox">
                                        <input className="form__checkbox__input" type="checkbox" value="Microsoft Approvals"
                                               id="incident_0" name="incident_0" data-field-name="incident_0" onClick={()=> handleChange("powerApps","Approvals")}/>
                                        <label className="form__checkbox__label" htmlFor="incident_0">
                                            <span className="form__checkbox__icon"></span>
                                            <span className="form__checkbox__text"><p> {translations['microsoftApprovals']} </p></span>
                                        </label>
                                    </div>

                                    <div className="form__checkbox">
                                        <input className="form__checkbox__input" type="checkbox" value="Helpdesk" id="incident_1"
                                               name="incident_1" data-field-name="incident_1"  onClick={()=> handleChange("powerApps","Helpdesk")}/>
                                        <label className="form__checkbox__label" htmlFor="incident_1">
                                            <span className="form__checkbox__icon"></span>
                                            <span className="form__checkbox__text"><p> {translations['helpdesk']} </p></span>
                                        </label>
                                    </div>

                                    <div className="form__checkbox">
                                        <input className="form__checkbox__input" type="checkbox" value="Sales Hub" id="incident_2"
                                               name="incident_2" data-field-name="incident_2" onClick={()=> handleChange("powerApps","Space Book")}/>
                                        <label className="form__checkbox__label" htmlFor="incident_2">
                                            <span className="form__checkbox__icon"></span>
                                            <span className="form__checkbox__text"><p> {translations['spaceBook']} </p></span>
                                        </label>
                                    </div>

                                    <div className="form__checkbox">
                                        <input className="form__checkbox__input" type="checkbox" value="Reception - Hot Desk"
                                               id="incident_3" name="incident_3" data-field-name="incident_3" onClick={()=> handleChange("powerApps","Task Line")}/>
                                        <label className="form__checkbox__label" htmlFor="incident_3">
                                            <span className="form__checkbox__icon"></span>
                                            <span className="form__checkbox__text"><p>{translations['taskLine']} </p></span>
                                        </label>
                                    </div>

                                    <div className="form__checkbox">
                                        <input className="form__checkbox__input" type="checkbox" value="Time" id="incident_4"
                                               name="incident_4" data-field-name="incident_4" onClick={()=> handleChange("powerApps","Store")}/>
                                        <label className="form__checkbox__label" htmlFor="incident_4">
                                            <span className="form__checkbox__icon"></span>
                                            <span className="form__checkbox__text"><p> {translations['store']} </p></span>
                                        </label>
                                    </div>

                                    <div className="form__checkbox">
                                        <input className="form__checkbox__input" type="checkbox" value="Store" id="incident_5"
                                               name="incident_5" data-field-name="incident_5" onClick={()=> handleChange("powerApps","Sales Track")}/>
                                        <label className="form__checkbox__label" htmlFor="incident_5">
                                            <span className="form__checkbox__icon"></span>
                                            <span className="form__checkbox__text"><p> {translations['salesTrack']} </p></span>
                                        </label>
                                    </div>
                                </div>

                            </div>


                        </div>

                        <div className="fixed_line_box text-align-start" style={ thanks ? {display: 'none'} : {display: 'block'}}>
                            <div className="form__checkbox">
                                <input className="form__checkbox__input form__input form__validate__field required" type="checkbox"
                                       value="1" id="yourBusinessOnline" name="yourBusinessOnline"
                                       data-field-name="yourBusinessOnline" onChange={()=> handleChange("business",null)}/>
                                <label htmlFor="yourBusinessOnline" className="form__checkbox__label input_checkbox_label">
                                    <span className="form__checkbox__icon input_checkbox_box"></span>
                                    <span className="form__checkbox__text pl-40">
						<p className="businessDigital_label" style={{color:"black", marginRight:"5px", fontWeight: "bold"}}>{translations['business']}</p>

					</span>
                                </label>
                            </div>
                            <div className="form__checkbox">
                                <input className="form__checkbox__input form__input form__validate__field required" type="checkbox"
                                       value="1" id="digitalMarketingForU" name="digitalMarketingForU"
                                       data-field-name="digitalMarketingForU" onChange={()=> handleChange("marketing" , null)} />
                                <label htmlFor="digitalMarketingForU" className="form__checkbox__label input_checkbox_label">
                                    <span className="form__checkbox__icon input_checkbox_box"></span>
                                    <span className="form__checkbox__text pl-40">
						<p className="businessDigital_label" style={{color:"black", marginRight:"5px",fontWeight: "bold"}}>{translations['marketing']}</p>

					</span>
                                </label>
                            </div>
                        </div>
                        <div className="wcs-legal" style={ thanks ? {display: 'none'} : {display: 'block'}}>{translations['exisingCustomer']}
                        </div>
                        <hr className="wcs-legal-hr"/>
                        <h3 className="wcs-text">{translations['fillPhoneNumber']}</h3>
                        <hr className="wcs-legal-hr"/>
                        <div className="wcs-form">
                            <form className="needs-validation" id="contactForm" noValidate="">
                                <div id="emailAttachmentForm">
                                    <div className="validate-me d-flex justify-content-center">
                                                <span className="validate-me" style={ thanks ? {display: 'none'} : {display: 'block'}}>
                                                    <input className="wcs-frm-phone form__input full-width form__validate__field required"
                                                           id="phone" maxLength="10" minLength="10" name="phone"
                                                           placeholder={translations['placeholderPhone']}  type="tel" value={phoneNumber ? `${phoneNumber}`: ''}
                                                           data-form-validate-number="true" onChange={(e)=> handleChange("phoneNumber",e.target.value)}/>
                                                        <span className="form__error-message">{translations['errorMessage']}</span>
                                                    </span>
                                        <button
                                            className={createClass("wcs-submit button  form__validate__submit ",button ? "" :"button--disabled" )}
                                            onClick={getCall}
                                            type="button"
                                            disabled={!button}>{translations['callMe']}
                                        </button>
                                    </div>
                                </div>
                            </form>

                        </div>
                        <div className="wcs-thank wcs-callmeback-thank" style={thanks ? {display: "block"} :{display: "none"}}>
                            <div className="wcs-icon"></div>
                            <div className="wcs-title wcs-callmeback-thank-title">{translations['thanks']}</div>
                            <div className="wcs-text wcs-callmeback-thank-text">
                                {message}
                            </div>
                            <a className="wcs-back" onClick={getBack} >{translations['goBack']}</a></div>



                    </div>
                    {cards && cards.length > 0 ? cards?.map((cardList, index) => (
                        <div className="wcs-cards row" key={index}>
                            {cardList?.attributes?.reusables && cardList?.attributes?.reusables.length > 0 ? cardList?.attributes?.reusables?.map((reusable,ind)=>(
                                <span key={ind}>
                                {reusable?.item && reusable?.item?.length >0 ? reusable?.item?.map((card,i)=> (
                                    <span key={i}>
                                        <CardComponent title={card?.title} img={card?.image?.data?.attributes?.url} scale={card?.image?.data?.attributes?.size} url={card?.url}/>
                                    </span>
                                )): ""}
                                </span>
                            )):""}

                        </div>
                    )): ""}

                    {faqsData  &&
                        <div className="wcs-faq" >
                            <div className="wcs-title">{translations['faq']}</div>
                            <div className="wcs-items" >
                                {faqsData?.attributes?.common_faqs?.data && faqsData?.attributes?.common_faqs?.data?.length>0 ? faqsData?.attributes?.common_faqs?.data?.map((faq,index) => (
                                    <span key={index}>
                                        <FaqComponent index={index} title={faq?.attributes?.Title} content={faq?.attributes?.Content}/>
                                    </span>
                                )): ""}
                            </div>
                        </div>
                    }




                </div>
                {/*  <div className="col-md-2 p-0 pattern_blue_green">
                    <img
                        src={pinkPattern}/>
*/}
                    <div className="col-md-2 p-0 side-grey-bg" >
                </div>
            </div>

        </>
        )

    )
}

export default SelectOptions;
